import { Box, Modal } from 'app/components/design-system-components'

function EmpHistoryNotPresentModal({
  isSkipped = false,
  toggleModal = () => {},
  secondaryAction = () => {},
  primaryAction = () => {},
}) {
  const modalHeading = isSkipped ? 'Are you Sure?' : 'Add Employment'
  const modalBody = isSkipped ? (
    <Box>
      Please note that your payslip wont be able to be cross-checked against
      your employment details.
    </Box>
  ) : (
    <Box>
      Please add employment first so we can cross-check your payslip details.
    </Box>
  )

  return (
    <Modal
      modalBody={modalBody}
      modalFooter={undefined}
      primaryLabel="Add Employment"
      primaryAction={primaryAction}
      secondaryLabel="Skip"
      secondaryAction={secondaryAction}
      toggleModal={toggleModal}
      modalHeading={modalHeading}
    />
  )
}

export default EmpHistoryNotPresentModal
